import { TFunction } from 'react-i18next';
import { PropertyType } from '@/models/property.model';

export const getPropertyTypeOptions = (t: TFunction) =>
  Object.values(PropertyType).map((value) => ({
    value,
    label: t(`property_type_${value}`, { ns: 'common' }),
  }));
